import React, { useState } from "react";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import "../Service/ServiceGallery.css";

const ServiceGallery = (props) => {
  const imageData = props?.imageData || [];
  const [data, setData] = useState({ img: "", i: 0 });
  const [fade, setFade] = useState(false);

  const imageAction = (action) => {
    let i = data.i;

    if (action === "next-img") {
      const nextIndex = (i + 1) % imageData.length;
      setFade(false); // reset fade
      setTimeout(() => {
        setData({ img: imageData[nextIndex].src, i: nextIndex });
        setFade(true); // trigger fade
      }, 50); // small delay
    } else if (action === "previous-img") {
      const prevIndex = (i - 1 + imageData.length) % imageData.length;
      setFade(false);
      setTimeout(() => {
        setData({ img: imageData[prevIndex].src, i: prevIndex });
        setFade(true);
      }, 50);
    } else if (!action) {
      setData({ img: "", i: 0 });
    }
  };

  return (
    <>
      {data.img && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(21, 21, 21, 0.9)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            padding: "20px",
            boxSizing: "border-box",
          }}
        >
          {/* Close Button */}
          <button
            style={{
              position: "absolute",
              top: "20px",
              right: "20px",
              fontSize: "24px",
              color: "#fff",
              background: "transparent",
              border: "none",
              cursor: "pointer",
            }}
            onClick={() => imageAction()}
          >
            ✕
          </button>

          {/* Image and Arrows Wrapper */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              maxWidth: "1000px",
            }}
          >
            {/* Left Arrow - Always Visible */}
            <button
              onClick={() => imageAction("previous-img")}
              style={{
                fontSize: "30px",
                color: "white",
                background: "transparent",
                border: "none",
                cursor: "pointer",
                padding: "10px",
              }}
            >
              ←
            </button>

            {/* Image */}
            <img
              src={data.img}
              alt={`Preview ${data.i}`}
              className={`popup-image ${fade ? "fade-in" : ""}`}
              loading="lazy"
            />

            {/* Right Arrow - Always Visible */}
            <button
              onClick={() => imageAction("next-img")}
              style={{
                fontSize: "30px",
                color: "white",
                background: "transparent",
                border: "none",
                cursor: "pointer",
                padding: "10px",
              }}
            >
              →
            </button>
          </div>
        </div>
      )}

      {/* Gallery Grid */}
      <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 4 }}>
        <Masonry gutter="0px">
          {imageData.map((image, i) => (
            <div
              className="box"
              key={i}
              onClick={() => setData({ img: image.src, i })}
            >
              <img
                src={image.src}
                alt={image.text || `Gallery ${i}`}
                style={{
                  width: "100%",
                  display: "block",
                  cursor: "pointer",
                }}
                loading="lazy"
              />
              <div className="box-content">
                <h3 className="name">{image.text}</h3>
                <span className="post">{image.text}</span>
              </div>
            </div>
          ))}
        </Masonry>
      </ResponsiveMasonry>
    </>
  );
};

export default ServiceGallery;
